import Vue from '/builds/gitlab/gitlab-ee/app/assets/javascripts/lib/utils/vue3compat/vue.js?vue3';
import VueApollo from '/builds/gitlab/gitlab-ee/app/assets/javascripts/lib/utils/vue3compat/vue_apollo.js?vue3';
import VueRouter from '/builds/gitlab/gitlab-ee/app/assets/javascripts/lib/utils/vue3compat/vue_router.js?vue3';
import { initVueApp } from '/builds/gitlab/gitlab-ee/app/assets/javascripts/lib/utils/vue3compat/init_vue_app.js?vue3';
import ExploreGroupsApp from '/builds/gitlab/gitlab-ee/app/assets/javascripts/explore/groups/components/app.vue?vue3';
import createDefaultClient from '/builds/gitlab/gitlab-ee/app/assets/javascripts/lib/graphql.js?vue3';
import { resolvers } from '/builds/gitlab/gitlab-ee/app/assets/javascripts/vue_shared/components/groups_list/resolvers.js?vue3';
import routes from '/builds/gitlab/gitlab-ee/app/assets/javascripts/explore/groups/routes.js?vue3';

Vue.use(VueRouter);
Vue.use(VueApollo);

export const createRouter = (basePath) => {
  const router = new VueRouter({
    routes,
    mode: 'history',
    base: basePath,
  });

  return router;
};

export const initExploreGroups = () => {
  const el = document.getElementById('js-explore-groups');

  if (!el) return null;

  const { initialSort, endpoint, basePath } = el.dataset;

  const apolloProvider = new VueApollo({
    defaultClient: createDefaultClient(resolvers(endpoint)),
  });

  return initVueApp({
    el,
    router: createRouter(basePath),
    apolloProvider,
    name: 'ExploreGroupsRoot',
    component: ExploreGroupsApp,
    props: { initialSort },
  });
};
